import { BitmapText, Text } from 'pixi.js'
import gsap from 'gsap'
import { formatToCommaWithLang, toCommaOptions } from './formatUtil'

export const numberAnimation = (startNum: number, endNum: number, duration: number, component: BitmapText | Text, option = toCommaOptions.forceTwoDecimalPlaces): [Promise<void>, () => void] => {
  const displayNum = { value: startNum }
  let isSkip = false
  const anim = new Promise<void>((resolve) => {
    const task = gsap.to(displayNum, {
      value: endNum,
      duration: duration,
      onUpdate: () => {
        if (isSkip) {
          component.text = formatToCommaWithLang(endNum, navigator.language, option)
          resolve()
          task.kill()
          return
        }
        component.text = formatToCommaWithLang(displayNum.value, navigator.language, option)
      },
      onComplete: () => {
        resolve()
      },
    })
  })

  return [anim, () => isSkip = true]
}

export const numberAnimationWithFixedDuring = (startNum: number, endNum: number, duration: number, component: BitmapText | Text, option = toCommaOptions.forceTwoDecimalPlaces): [Promise<void>, () => void] => {
  const displayNum = { value: startNum }
  let isSkip = false
  const anim = new Promise<void>((resolve) => {
    const task = gsap.to(displayNum, {
      value: endNum,
      duration: duration,
      onUpdate: () => {
        if (isSkip) {
          component.text = formatToCommaWithLang(endNum, navigator.language, option)
          resolve()
          task.kill()
          return
        }
        component.text = formatToCommaWithLang(displayNum.value, navigator.language, toCommaOptions.forceTwoDecimalPlaces)
      },
      onComplete: () => {
        component.text = formatToCommaWithLang(displayNum.value, navigator.language, option)
        resolve()
      },
    })
  })

  return [anim, () => isSkip = true]
}
